(function(){
  var setPaddingToBody = function(){
    var headerHeight= $(".header-outer-container").height();
    $("body.main_body").css("padding-top",headerHeight);
  }
  $(document).ready(function(){
    setPaddingToBody();
  });
  $( window ).resize(function(){
    setPaddingToBody();
  }); 

})();

jQuery(window).on("load", function(){
  jQuery(".slideshow__arrow-left").attr("disabled", "disabled");
  jQuery("button.slick-prev.slick-arrow").attr("disabled", "disabled");
  jQuery("button.slick-prev.slick-arrow").removeClass("slick-disabled");

  var tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


});

jQuery(document).ready(function(){
  jQuery(document).on("click", ".next_type_dots", function(){
    jQuery(".next_btn_rev").click();
    jQuery(".prev_type_dots").show();
    jQuery(".next_type_dots").hide();
  });
  jQuery(document).on("click", ".prev_type_dots", function(){
    jQuery(".prev_btn_rev").click();
    jQuery(".next_type_dots").show();
    jQuery(".prev_type_dots").hide();
  });
  jQuery(document).on("click", ".next", function(){
    $(window).scrollTop(0);
    jQuery(".prev_type_dots").show();
    jQuery(".next_type_dots").hide();
  });
  jQuery(document).on("click", ".prev", function(){
    $(window).scrollTop(0);
    jQuery(".next_type_dots").show();
    jQuery(".prev_type_dots").hide();
  });

  
  
  jQuery('.off-image').addClass('show-image');
  //homepage product section tooltip

    jQuery(document).on('click','.tool-tip',function(){
  
    if(jQuery(this).hasClass('active-tooltip')) {
      jQuery(this).next('.tool-tip-content').hide('fast');
      jQuery(this).removeClass('active-tooltip');
    }
    else
    {
      jQuery('.tool-tip-content').hide('fast');
      jQuery('.tool-tip').removeClass('active-tooltip');
      jQuery(this).addClass('active-tooltip');
      jQuery(this).next('.tool-tip-content').show('fast');
    }

  });

//   jQuery(document).on('click','body',function(e){
//    console.log(e.target.className);
//    if(e.target.className != "tool-tip")
//      jQuery('.tool-tip-content').hide('fast');
//      jQuery('.tool-tip').removeClass('active-tooltip');
//     });
  
        $(document).on('click', function (event) {
          if (!$(event.target).closest('.tool-tip-container').length) {
            $('.tool-tip-content').hide();
            $('.tool-tip').removeClass('active-tooltip');
            // ... clicked on the 'body', but not inside of #menutop
          }
        });
  // end homepage product section

  //collection tool tip

  jQuery(document).on('click','.option-info.small--hide',function(){


    if(jQuery(this).hasClass('active-tooltip'))
    {
      jQuery(this).removeClass('active-tooltip');
    }
    else
    {
      jQuery('.option-info').removeClass('active-tooltip');
      jQuery(this).addClass('active-tooltip');
    }

  });
  jQuery(document).on('click','.option-info.medium-up--hide',function(){


    if(jQuery(this).hasClass('active-tooltip'))
    {
      jQuery('.option-info').removeClass('active-tooltip');
    }
    else
    {
      jQuery('.option-info').removeClass('active-tooltip');
      jQuery(this).addClass('active-tooltip');
	  jQuery('.option_info_overlay').addClass('active');
	  jQuery('body').addClass('no_scroll');
    }

  });
  $(".option_info_overlay").click(function(e){
	jQuery(this).removeClass('active');
    if(e.target.className != "option-info")
    {
      jQuery(".option-info").removeClass("active-tooltip");
      jQuery(this).removeClass('active-tooltip');
	  jQuery('body').removeClass('no_scroll');
    }
  });
  $("body").click(function(e){
    if(e.target.className != "option-info")
    {
      jQuery(".option-info").removeClass("active-tooltip");
      jQuery(this).removeClass('active-tooltip');
      jQuery('body').removeClass('no_scroll');
      jQuery('.option_info_overlay').removeClass('active');
    }
  });
  //end collection tool tio

  // home page switch button image js
  $('#myonoffswitch').click(function(){
    if($(this).prop("checked") == true){
      jQuery('.on-image').removeClass('show-image');
      jQuery('.off-image').addClass('show-image');
    }
    else if($(this).prop("checked") == false){
      jQuery('.off-image').removeClass('show-image');
      jQuery('.on-image').addClass('show-image');
    }
  });
  // end switch button js
  $('.section-slider').slick({
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: false
  });
  jQuery('.tab-icon-text').click(function(){
    $('.review-slider').slick('slickGoTo', jQuery(this).data('tab-index'));
  });
  $('.review-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var dataId = $(slick.$slides[currentSlide]).data('slick-index');  
    jQuery(".tab-icon-text").removeClass('active-tab');
    jQuery(".tab-icon-text[data-tab-index="+dataId+"]").addClass('active-tab');
  });

  jQuery('.jtpl-main-nav-link').click(function(e){

    e.stopPropagation();
    var redirecturl = jQuery(this).data('link-url');
    $(location).attr('href', redirecturl);

  });

  if(jQuery('body').hasClass('template-product'))
  {
    var mytext=jQuery('.swatch[data-option-index="0"] .header').data('text');

    if (mytext == "Size") {
      var size = ""
      var sizeReversed = ""
      if (jQuery('.swatch[data-option-index="0"] .header').data("sizeSystem") == "inch") {
        sizeReversed = (jQuery('#SingleOptionSelector-0').val() * 2.54).toFixed(1).toString().replace('.0','').replace('.',',') + " cm"
        size = jQuery('#SingleOptionSelector-0').val() + "”"
      }
      else {
        sizeReversed = jQuery('#SingleOptionSelector-0').val() + "”"
        size = (jQuery('#SingleOptionSelector-0').val() * 2.54).toFixed(1).toString().replace('.0','').replace('.',',') + " cm"
      }
      jQuery('.swatch[data-option-index="0"] .header-streight').html(mytext+': <strong>'+ size +'</strong>');
      jQuery('.swatch[data-option-index="0"] .header.header-reversed').html(mytext+': <strong>'+ sizeReversed +'</strong>');
    }
    else {
      jQuery('.swatch[data-option-index="0"] .header').html(mytext+': <strong>'+jQuery('#SingleOptionSelector-0').val())+'</strong>';
    }
    var mytext=jQuery('.swatch[data-option-index="1"] .header').data('text');
    // console.log('jako faaakt', jQuery('#SingleOptionSelector-1'), jQuery('#SingleOptionSelector-1').val())
    // jQuery('.swatch[data-option-index="1"] .header').html(mytext+': <strong> '+jQuery('#SingleOptionSelector-1').val())+'</strong>';
  }

  jQuery('.swatch-element').click(function(e){
    var mytext=jQuery(this).parents('.swatch').find('.header').data('text');
    if (mytext == "Size") {
      var size = ""
      var sizeReversed = ""
      if (jQuery('.swatch[data-option-index="0"] .header').data("sizeSystem") == "inch") {
        sizeReversed = (jQuery(this).data('value') * 2.54).toFixed(1).toString().replace('.0','').replace('.',',') + " cm"
        size = jQuery(this).data('value') + "”"
      }
      else {
        sizeReversed = jQuery(this).data('value') + "”"
        size = (jQuery(this).data('value') * 2.54).toFixed(1).toString().replace('.0','').replace('.',',') + " cm"
      }
      jQuery(this).parents('.swatch').find('.header-streight').html(mytext+': <strong>'+ size +'</strong>');
      jQuery(this).parents('.swatch').find('.header-reversed').html(mytext+': <strong>'+ sizeReversed +'</strong>');
    }
    else {
      if(!e.currentTarget.classList.contains('soldout')) {
        jQuery(this).parents('.swatch').find('.header').html(mytext+': <strong> '+jQuery(this).data('value'))+'</strong>';
      }
    }
  });

  jQuery("#hide_centimeter,#show_centimeter").click(function(){
    jQuery('.inches-cm-container .header').toggleClass('hide')
    jQuery('.size-inch-cm-variant').toggleClass('hide')
    jQuery('#show_centimeter').toggleClass('hide')
    jQuery('#hide_centimeter').toggleClass('hide')
  });

  jQuery(document).on("click", ".section--customer-says-about-us", function(){
    if(jQuery(this).find(".review-slid-item-1").hasClass("slick-active")){
      jQuery(".review-slider button.slick-prev").attr("disabled","disabled");
    }else{
      jQuery(".review-slider button.slick-prev").removeAttr("disabled","disabled");
    }
    if(jQuery(this).find(".review-slid-item-4").hasClass("slick-active")){
      jQuery(".review-slider button.slick-next").attr("disabled","disabled");
    }else{
      jQuery(".review-slider button.slick-next").removeAttr("disabled","disabled");
    }
  });
  jQuery(document).on("afterChange", ".index-section--slideshow", function(){
    if(jQuery(this).find(".review-slid-item-1").hasClass("slick-active")){
      jQuery(".index-section--slideshow .slideshow__arrow-left").attr("disabled","disabled");
    }else{
      jQuery(".index-section--slideshow .slideshow__arrow-left").removeAttr("disabled","disabled");
    }

    let slidesCount = jQuery(this).find(".slideshow__slide").length
    if(jQuery(this).find(".review-slid-item-"+slidesCount).hasClass("slick-active")){
      jQuery(".index-section--slideshow .slideshow__arrow-right").attr("disabled","disabled");
    }else{
      jQuery(".index-section--slideshow .slideshow__arrow-right").removeAttr("disabled","disabled");
    }
  }); 
  
});
 
$(document).ready(function(){
  $(".site-nav--has-dropdown").hover(function(){
  $(this).toggleClass("site-nav--active-dropdown");
});
//menu dropdown click
$('.js-toggle-submenu.mobile-nav__link').click(function(event) {
$(this).toggleClass("is-active");
$(this).parent('.mobile-nav__item').toggleClass("active");
});
//end 
//shop page comparison hide show on mobile
$('#shop_comparison').click(function(){
$(this).hide();    
$('.shop_comparison-tab').removeClass('small--hide');
});
$('#hide_comparison').click(function(){
$(this).parent('.shop_comparison-tab').addClass('small--hide');
$('#shop_comparison').show();
});
//end

// homepage customer-says-about-us section slider
var windowWidth = $( window ).width();
if(windowWidth < 750){
  
  $('.product_single_image_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
	  dots: true,
    arrows: false,
    infinite: false
});

$(".product_single_image_slider").slick('slickFilter', function(index) {
  return $(this).hasClass("filter")
});
  

    
}
$('.review-slider').slick({
  fade: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  infinite: false,
  //     asNavFor: '.customer-tab-slider',
  customPaging: function(slick, index) {
    return  (index + 1) + '&nbsp;/&nbsp;' + slick.slideCount;
  }
});
});
// end
 
var elem = document.querySelector(".header-outer-container");

var headroom = new Headroom(elem, {
  "offset": 205,
  "tolerance": 5,
  "classes": {
    "initial": "headeroom",
    "pinned": "slideDown headroom--pinned",
    "unpinned": "slideUp headroom--unpinned",
    "top" : "headroom--top",
    "bottom" : "headroom--bottom",
    "notTop" : "headroom--not-top",
  }
});
headroom.init();


$(document).ready(function(){
// $('.swatch_container .soldout input').removeAttr("checked"); 
//   $('.swatch_container').each(function(){
//   $('.swatch-element input:checked + label').addAttr("checked");
//   });
  
// var selectval =  $('.swatch').find('.header strong').text();
  
//     $('.swatch_container').each(function(){
//       var all_swatches = $('.swatch-element input').val();
//       if(all_swatches==selectval){
//       this.addAttr('checked');
//       }  
//     });
  


  
  
  
});
/*jQuery(document).on('click', ".template-product .product-single__meta .spr-badge", function() {
    jQuery(".product_tab .tab .tablinks").each(function() {
        var txt = jQuery(this).text();
        var res = txt.toLowerCase();
        if (res.indexOf("review") != -1) {
            jQuery('html, body').animate({
                scrollTop: jQuery(".product_tab").offset().top
            }, 500);
          
            openTab(event, 'reviews');
            this.classList.add("active");

        }
    });
});*/
jQuery(document).on('click', '.product-card .product-info .spr-badge', function() {
    var url = $(this).parents(".product-info").find(".item-title-price a").attr("href");
    var origin = window.location.origin;
    var id = "?review=yes";
    var orgurl = origin + url + id;

    window.location.href = orgurl;


});

///slideshow video functions:
const onSlideshowPlayerReady = (event) => {
  $(".slideshow--video-modal").addClass("player-ready")
}
$(".slideshow__buttons .btn-video, .slideshow-mobile-video-play").on("click",(e)=>{
  e.preventDefault();

  //move modal vertically to its position:
  if($(window).width() < 750 && $(window).height() > ($(window).width() / 16 * 9) ) {
    let modalYPos = $(e.target).parent().offset().top
    $(".slideshow--video-wrapper").css("margin-top", modalYPos + "px")
  } else {
    $(".slideshow--video-wrapper").css("margin-top", "auto")
  }

  let videoID = $(e.target).data("video")
  $(".slideshow--video-modal").removeClass("hide")
  let playerWidth = $("#slideshowVideo").width()
  let playerHeight = Math.round(playerWidth / 16 * 9)/1 // 16/9 ratio
  $(".slideshow--video-wrapper").css("height",playerHeight+ "px")
  let player
  player = new YT.Player('slideshowVideo', {
    height: playerHeight,
    width: playerWidth,
    videoId: videoID,
    playerVars: {
      // 'autoplay': 1,
      'showinfo': 0,
      // 'playsinline': 1
    },
    events: {
      'onReady': onSlideshowPlayerReady
    }
  })
})

$(".slideshow--video-wrapper-close, .slideshow--video-modal-bg").on("click",(e)=>{
  e.preventDefault();
  $(".slideshow--video-modal").addClass("hide")
  $("#slideshowVideo").replaceWith('<div id="slideshowVideo"></div>')
  $(".slideshow--video-modal").removeClass("player-ready")
})

//show name of option value on option label hover:
jQuery(document).on('mouseenter', '.swatch_container label', (e) => {
  e.preventDefault()
  let selectedEl = $(e.target)
  let container = $(".swatch_container")
  let val = selectedEl.parent().attr("data-value")
  container.prev().find("strong").html(val)
});

jQuery(document).on('mouseleave', '.swatch_container label', (e) => {
  e.preventDefault()
  let container = $(".swatch_container")
  container.prev().find("strong").html( container.find("input:checked").val() )
});

$(window).on('load', function() {
  var pageUrl = window.location.href;
	/*if (pageUrl.indexOf("review=yes") != -1) {
    jQuery(".product_tab .tab .tablinks").each(function() {
        var txt = jQuery(this).text();
        var res = txt.toLowerCase();
        if (res.indexOf("review") != -1) {
           jQuery('html, body').animate({
                scrollTop: jQuery(".product_tab").offset().top
            }, 500);
            openTab(event, 'reviews');
            this.classList.add("active");

        }
    });
    }*/

    //quantity buttons on product page:
    jQuery(document).on('click', '.quantity_minus', (evt) => {
      evt.preventDefault()
      let qtyInput = $("[data-quantity-input]")
      if (parseInt(qtyInput.val()) >= parseInt(qtyInput.attr("min")) + 1) {
        qtyInput.val(parseInt(qtyInput.val()) - 1)
      }
    });
    jQuery(document).on('click', '.quantity_plus', (evt) => {
      evt.preventDefault()
      let qtyInput = $("[data-quantity-input]")
      //if (parseInt(qtyInput.val()) < parseInt(qtyInput.attr("max")) - 1) {
        qtyInput.val(parseInt(qtyInput.val()) + 1)
      //}
    });

    // Global discount buy button handler
    jQuery(document).on('click', '[data-global-discount-add]', function(evt) {
      evt.preventDefault();
      var $btn = $(this);
      var variantId = $btn.attr('data-variant-id');

      if (!variantId) return;

      $btn.prop('disabled', true);

      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: {
          id: variantId,
          quantity: 1
        }
      })
      .done(function() {
        if (typeof getCartHtml === 'function') {
          getCartHtml();
        }
        window.location.href = '/cart';
      })
      .fail(function(response) {
        var errorMessage = response.responseJSON ? response.responseJSON.description : 'Error adding to cart';
        alert(errorMessage);
      })
      .always(function() {
        $btn.prop('disabled', false);
      });
    });

});